var site = site || {};

site.window = {
	scrollPosition: 0
};

site.device = {
	// Check if device is a touch device
	isTouch: function() {
		try {
			document.createEvent("TouchEvent");
			return true;
		} catch (e) {
			return false;
		}
	}
};


// A few layout methods
site.layout = {
	// Wrap elements into a div.row
	rowWrap: function(selectorBegin, selectorEnd, extraClasses) {
		if (selectorEnd == undefined) {
			selectorEnd = selectorBegin;
		}

		if (extraClasses == undefined) {
			extraClasses = '';
		}

		$(selectorBegin).nextUntil(selectorEnd).andSelf().add(selectorEnd)
			.wrapAll("<div class='row " +extraClasses+ "'></div>");
	}
}


site.owl = {
	// Shorthand to init owlcarousel
	init: function(id, options) {
		var $owl = $(id);
		if ($owl.length > 0) {
			$owl.addClass('owl-carousel'); // This is to fix a change made in owl 2.0.0-beta.3
			$owl.owlCarousel(options);
		}
	}
};

site.nav = {
	// Init navigation scripts
	init: function() {
		// Add expand link to mobile menu
		//$('.children', '#mMenu ').prepend('<a class="expand" href="#"><span>+</span></a>');

		site.nav.bind();
	},
	bind: function() {
		// Mobile menu toggle
		$('#mainmenuToggle').click(function(e) {
			var menuOpen = $('body').hasClass('mainmenu-open');
			if (!menuOpen) {
				site.window.scrollPosition = $(window).scrollTop();
			}
			site.nav.mobileToggle(e, menuOpen, site.window.scrollPosition);
			e.preventDefault();
		});

		// Expand in mobile menu
		$('.expand', '#mMenu').bind('click', function(e) {
			e.preventDefault();

			var $this = $(this);
			var $ul = $this.siblings('ul');

			$ul.toggleClass('hide');
			$this.next().toggleClass('down');
			$this.toggleClass('down');
			e.preventDefault();
		});
	},
	// Toggle mobile menu
	mobileToggle: function(e, menuOpen, scrollPosition) {
		$('body').toggleClass('mainmenu-open');
		$(this).toggleClass('open');
		if (!menuOpen) {
			$(window).scrollTop(0);
			$('i', '#mainmenuToggle').removeClass('fa-bars').addClass('fa-close');
		}
		else {
			$(window).scrollTop(scrollPosition);
			$('i', '#mainmenuToggle').removeClass('fa-close').addClass('fa-bars');
		}
	},
	// Append language to mobilemenu
	appendLanguage: function() {
		var $divisions = $('.menu', '#divisions');
		var $menu = $('ul.mmLevel1', '#mMenu');

		var $html = $('<li class="ele-language si level1"></li>');
		$divisions.find('li').each(function() {
			var $li = $(this).clone();
			$html.append($li.find('a'));
		});

		$menu.append($html);
	}
};

site.frontpage = {
	init: function() {
		var $tabs = $('#main .countryTabs');
		var $content = $('#main .countries');
		$content.find('li > strong').parent().addClass('section');

		$tabs.find('li').click(function(e) {
			$this = $(this);
			var index = $this.index();
			var box = '.box_ord_'+index;
			if($this.hasClass('selected')) {
				$this.toggleClass('selected');
				$content.find(box).removeClass('open');
			}
			else {
				$tabs.find('li').removeClass('selected');
				$content.find('.box').removeClass('open');
				$this.toggleClass('selected');
				$content.find(box).toggleClass('open');

				var scrollPosition = $('#main .countries').offset().top - 8;
				$("html, body").animate({scrollTop: scrollPosition}, 600);
			}
			e.preventDefault();
		});
	}
};

site.country = {
	set: function() {
		var country = $.cookie('saeplastCountry');
		if(country) {
			var $link = $('.countries').find('a:contains("'+country+'")');
			$('#main .countryLast a').text(country).attr('title',country).attr('href',$link.attr('href'));
		}
	},
	add: function() {
		var $dialog = $('#main .countries ul');
		$dialog.find('a').click(function(e) {
			var $country = $(this);
			$.cookie('saeplastCountry', $country.text(), {expires: 365, domain: '.saeplast.com'});
		});
	}
};

// Run all the inits \o/
$(function() {
	site.nav.init();
	site.country.set();
	site.country.add();



	if($('body').hasClass('frontpage')) {
		site.frontpage.init();
	}
	// Responsive vimeo player
	//var $i = $('iframe', '#center');
	//if ($i.length > 0 && $i.attr('src').indexOf('player.vimeo.com') != -1) {
	//	$i.wrap('<div class="vimeoPlayer"></div>');
	//}

	// Responsive tables
	/*$('table', '#center').wrap('<div class="responsiveTable"></div>');*/

	// Touch login
	$('.login').bind('click', function(e) {
		e.preventDefault();
		window.location = '/moya';
	});

	// Reorder language menu based on selected
	// Move is to the top
	//$li = $('.selected', '#divisions');
	//$ul = $('.menu', '#divisions');
	//$ul.prepend($li);
});
